// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-overview {
  padding: var(--spacing-md);
  max-width: 1400px;
  margin: 0 auto;
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: var(--spacing-lg);
  margin-bottom: var(--spacing-xl);
}

.metric-card {
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--border-radius-lg);
  padding: var(--spacing-lg);
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  box-shadow: var(--shadow-sm);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.metric-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.metric-content {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
}

.metric-label {
  color: var(--text-muted);
  font-size: var(--font-size-sm);
  font-weight: 500;
}

.metric-value {
  color: var(--text-main);
  font-size: var(--font-size-xxxl);
  font-weight: 700;
  line-height: 1;
}

.metric-trend {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: var(--font-size-xs);
  margin-top: var(--spacing-xs);
}

.trend-up {
  color: var(--success);
}

.trend-down {
  color: var(--danger);
}

.metric-icon {
  background: var(--hover-bg);
  color: var(--accent);
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}

.charts-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: var(--spacing-lg);
  margin-bottom: var(--spacing-xl);
}

.chart-card {
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--border-radius-lg);
  padding: var(--spacing-lg);
  box-shadow: var(--shadow-sm);
}

.chart-header {
  margin-bottom: var(--spacing-lg);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.chart-title {
  color: var(--text-main);
  font-size: var(--font-size-lg);
  font-weight: 600;
  margin: 0;
}

.services-section {
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--border-radius-lg);
  padding: var(--spacing-lg);
  box-shadow: var(--shadow-sm);
}

.section-header {
  margin-bottom: var(--spacing-lg);
}

.section-title {
  color: var(--text-main);
  font-size: var(--font-size-xl);
  font-weight: 600;
  margin: 0;
}

.services-table-container {
  overflow-x: auto;
}

.services-table {
  width: 100%;
  border-collapse: collapse;
}

.services-table th {
  text-align: left;
  padding: var(--spacing-md);
  color: var(--text-muted);
  font-size: var(--font-size-sm);
  font-weight: 600;
  border-bottom: 1px solid var(--border);
}

.services-table td {
  padding: var(--spacing-md);
  border-bottom: 1px solid var(--border);
  color: var(--text-main);
}

.services-table tr:last-child td {
  border-bottom: none;
}

.services-table tr {
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.services-table tr:hover {
  background-color: var(--hover-bg);
}

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 9999px;
  font-size: var(--font-size-xs);
  font-weight: 500;
}

.status-active {
  background: rgba(16, 185, 129, 0.1);
  color: var(--success);
}

.status-inactive {
  background: rgba(239, 68, 68, 0.1);
  color: var(--danger);
}

.provider-list {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.provider-pill {
  background: var(--hover-bg);
  padding: 2px 8px;
  border-radius: 4px;
  font-size: var(--font-size-xs);
  color: var(--text-muted);
}

/* Modal styles for service details */
.service-details-modal {
  padding: var(--spacing-lg);
}

.service-detail-row {
  display: flex;
  justify-content: space-between;
  padding: var(--spacing-md) 0;
  border-bottom: 1px solid var(--border);
}

.service-detail-row:last-child {
  border-bottom: none;
}

.detail-label {
  color: var(--text-muted);
  font-weight: 500;
}

.detail-value {
  color: var(--text-main);
  font-weight: 600;
}

@media (max-width: 768px) {
  .charts-section {
    grid-template-columns: 1fr;
  }
  
  .metric-card {
    padding: var(--spacing-md);
  }
  
  .metric-value {
    font-size: var(--font-size-xxl);
  }
}

/* =============================================================================
   GraphAnalytics — Tab bar
   ============================================================================= */
.graph-analytics-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.analytics-tabs {
  display: flex;
  gap: 4px;
  padding: 12px 16px 0;
  background: var(--bg-secondary, #fff);
  border-bottom: 2px solid var(--border, #e4e4e7);
  flex-shrink: 0;
}

.tab-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 18px;
  border: none;
  background: transparent;
  color: var(--text-muted, #71717a);
  cursor: pointer;
  border-bottom: 3px solid transparent;
  font-size: 0.875rem;
  font-weight: 500;
  white-space: nowrap;
  transition: color .2s, border-color .2s;
  margin-bottom: -2px;
}
.tab-btn:hover  { color: var(--text-main, #18181b); }
.tab-btn.active {
  color: var(--accent, #2563eb);
  border-bottom-color: var(--accent, #2563eb);
  font-weight: 600;
}

.analytics-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
  background: var(--bg-primary, #f4f4f5);
}

/* additional chart sub-styles */
.chart-subtitle { margin: 4px 0 0 0; color: var(--text-muted, #71717a); font-size: 0.82rem; }
.chart-container { height: 280px; position: relative; }
.chart-container-bar { height: 320px; }
.no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 40px;
  color: var(--text-muted, #71717a);
  text-align: center;
}
.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 40px;
  color: var(--text-muted, #71717a);
  font-size: 0.9rem;
}

/* =============================================================================
   GraphAnalytics — Centrality tab
   ============================================================================= */
.centrality-container { display: flex; flex-direction: column; gap: 16px; }
.centrality-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.centrality-header h3 { margin: 0; font-size: 1.05rem; display: flex; align-items: center; gap: 8px; }
.centrality-controls { display: flex; align-items: center; gap: 8px; font-size: 0.85rem; color: var(--text-muted, #71717a); }
.centrality-limit-select {
  padding: 6px 10px;
  border: 1px solid var(--border, #e4e4e7);
  border-radius: 6px;
  background: var(--card-bg, #fff);
  color: var(--text-main, #18181b);
  font-size: 0.85rem;
}
.centrality-table { overflow-x: auto; }
.centrality-table table { width: 100%; border-collapse: collapse; font-size: 0.875rem; }
.centrality-table thead th {
  text-align: left;
  padding: 10px 14px;
  background: var(--hover-bg, #f4f4f5);
  color: var(--text-muted, #71717a);
  font-weight: 600;
  border-bottom: 1px solid var(--border, #e4e4e7);
  white-space: nowrap;
}
.centrality-table tbody tr {
  border-bottom: 1px solid var(--border, #f4f4f5);
  transition: background .15s;
}
.centrality-table tbody tr:hover { background: var(--hover-bg, #f8fafc); }
.centrality-table tbody tr:last-child { border-bottom: none; }
.centrality-table td { padding: 10px 14px; }
.rank-cell   { color: var(--text-muted, #71717a); font-weight: 600; }
.entity-cell { font-weight: 500; }
.degree-cell { font-weight: 700; color: var(--accent, #2563eb); }
.text-center { text-align: center; }
.type-badge  {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 5px;
  font-size: 0.7rem;
  font-weight: 700;
  white-space: nowrap;
}

/* =============================================================================
   GraphAnalytics — AI Insights tab
   ============================================================================= */
.insights-container { display: flex; flex-direction: column; gap: 16px; }
.insights-history-section { display: flex; flex-direction: column; gap: 14px; }

.insights-header {}
.insights-title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.insights-title-row h3 { margin: 0; font-size: 1rem; display: flex; align-items: center; gap: 8px; }
.insights-description { margin: 4px 0 0 0; font-size: 0.82rem; color: var(--text-muted, #71717a); }

.insights-controls { display: flex; align-items: center; gap: 8px; flex-shrink: 0; }
.insight-filter-select {
  padding: 7px 10px;
  border: 1px solid var(--border, #e4e4e7);
  border-radius: 6px;
  background: var(--card-bg, #fff);
  color: var(--text-main, #18181b);
  font-size: 0.82rem;
}
.sort-btn {
  padding: 7px 10px;
  border: 1px solid var(--border, #e4e4e7);
  border-radius: 6px;
  background: var(--card-bg, #fff);
  color: var(--text-muted, #71717a);
  cursor: pointer;
  font-size: 0.85rem;
  transition: all .2s;
}
.sort-btn:hover { border-color: var(--accent, #2563eb); color: var(--accent, #2563eb); }

/* Insight Tips (empty state) */
.insight-tips { list-style: none; padding: 0; margin: 8px 0 0 0; display: flex; flex-direction: column; gap: 6px; }
.insight-tips li { font-size: 0.82rem; color: var(--text-muted, #71717a); display: flex; align-items: center; gap: 8px; }
.insight-tips li i { color: var(--accent, #2563eb); width: 14px; text-align: center; }

/* Insight list */
.insights-list { display: flex; flex-direction: column; gap: 10px; }

/* ── Insight Card ── */
.insight-card {
  background: var(--card-bg, #fff);
  border: 1px solid var(--border, #e4e4e7);
  border-radius: 10px;
  overflow: hidden;
  transition: box-shadow .2s;
}
.insight-card:hover  { box-shadow: 0 4px 12px rgba(0,0,0,.08); }
.insight-card.expanded { border-color: var(--accent, #2563eb); }

.insight-card-header {
  padding: 12px 14px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  justify-content: space-between;
}
.insight-card-header.clickable { cursor: pointer; transition: background .15s; }
.insight-card-header.clickable:hover { background: var(--hover-bg, #f8fafc); }

.insight-header-main {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1 1;
  min-width: 0;
}

/* Type badge */
.insight-type-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 9px;
  border-radius: 5px;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: capitalize;
  white-space: nowrap;
  flex-shrink: 0;
  background: rgba(99,102,241,.12);
  color: #4f46e5;
}
.insight-type-badge.network_patterns      { background: rgba(37,99,235,.12);  color: #1d4ed8; }
.insight-type-badge.entity_summary        { background: rgba(16,185,129,.12); color: #059669; }
.insight-type-badge.relationship_analysis { background: rgba(245,158,11,.12); color: #b45309; }
.insight-type-badge.whiteboard_analytics    { background: rgba(139,92,246,.12); color: #7c3aed; }

/* Source context badge */
.insight-source-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 9px;
  border-radius: 5px;
  font-size: 0.72rem;
  font-weight: 500;
  background: var(--hover-bg, #f4f4f5);
  color: var(--text-muted, #71717a);
  border: 1px solid var(--border, #e4e4e7);
  white-space: nowrap;
  flex-shrink: 0;
}

/* Summary preview text */
.insight-summary-preview {
  flex: 1 1;
  font-size: 0.82rem;
  color: var(--text-muted, #71717a);
  line-height: 1.45;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  min-width: 120px;
}

.insight-header-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  font-size: 0.75rem;
  color: var(--text-muted, #71717a);
}
.insight-time { white-space: nowrap; }

/* Expanded body */
.insight-card-content {
  padding: 14px 16px;
  border-top: 1px solid var(--border, #e4e4e7);
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: var(--bg-primary, #fafafa);
}

/* Navigation button row */
.insight-nav-row { display: flex; justify-content: flex-end; }
.insight-nav-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 14px;
  background: var(--accent, #2563eb);
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity .15s, transform .12s;
}
.insight-nav-btn:hover { opacity: 0.88; transform: translateY(-1px); }
.insight-nav-btn--lead {
  background: #f59e0b;
  color: #fff;
}
.insight-nav-btn--lead:hover { opacity: 0.88; transform: translateY(-1px); }

/* Full summary */
.insight-full-summary { display: flex; flex-direction: column; gap: 6px; }
.insight-full-summary h4 {
  margin: 0;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .4px;
  color: var(--text-muted, #71717a);
}
.insight-full-summary p { margin: 0; font-size: 0.88rem; color: var(--text-main, #18181b); line-height: 1.6; }

/* Content sections */
.insight-section { display: flex; flex-direction: column; gap: 8px; }
.insight-section h4 {
  margin: 0;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .4px;
  color: var(--text-muted, #71717a);
  display: flex;
  align-items: center;
  gap: 6px;
}
.insight-section h4 i { color: var(--accent, #2563eb); }
.insight-section.risk h4 i { color: #ef4444; }
.insight-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.insight-section li {
  font-size: 0.85rem;
  color: var(--text-main, #18181b);
  line-height: 1.5;
  padding: 5px 10px 5px 12px;
  border-left: 3px solid var(--accent, #2563eb);
  background: rgba(37,99,235,.04);
  border-radius: 0 5px 5px 0;
}
.insight-section.risk li { border-left-color: #ef4444; background: rgba(239,68,68,.04); }

/* Sub-groups (whiteboard board_summary sections) */
.insight-sub-group { display: flex; flex-direction: column; gap: 5px; }
.insight-sub-label {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .4px;
  color: var(--text-muted, #71717a);
  display: flex;
  align-items: center;
  gap: 5px;
}
.insight-sub-label i { color: var(--accent, #2563eb); }
.insight-sub-group ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.insight-sub-group li {
  font-size: 0.83rem;
  color: var(--text-main, #18181b);
  line-height: 1.45;
  padding: 4px 8px 4px 10px;
  border-left: 2px solid var(--border, #e4e4e7);
  background: var(--hover-bg, #f8fafc);
  border-radius: 0 4px 4px 0;
}

/* =============================================================================
   Cross Domain Lead — card badge & score pill
   ============================================================================= */
.insight-card--lead {
  border-left: 3px solid #f59e0b;
}
.insight-card--lead.expanded {
  border-color: #f59e0b;
}

.insight-type-badge.cross_domain_lead {
  background: rgba(245, 158, 11, 0.12);
  color: #b45309;
}

/* Lead score pill shown in the insight card header */
.lead-score-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 9px;
  border-radius: 5px;
  font-size: 0.72rem;
  font-weight: 700;
  white-space: nowrap;
  flex-shrink: 0;
}
.lead-score-badge.lead-score-high {
  background: rgba(16, 185, 129, 0.12);
  color: #059669;
  border: 1px solid rgba(16, 185, 129, 0.3);
}
.lead-score-badge.lead-score-med {
  background: rgba(245, 158, 11, 0.12);
  color: #b45309;
  border: 1px solid rgba(245, 158, 11, 0.3);
}
.lead-score-badge.lead-score-low {
  background: rgba(239, 68, 68, 0.12);
  color: #dc2626;
  border: 1px solid rgba(239, 68, 68, 0.3);
}

/* =============================================================================
   Lead Modal — overlay & shell
   ============================================================================= */
.lead-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(3px);
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  animation: leadModalFadeIn 0.18s ease;
}

@keyframes leadModalFadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}

.lead-modal {
  background: var(--card-bg, #fff);
  border: 1px solid var(--border, #e4e4e7);
  border-top: 4px solid #f59e0b;
  border-radius: 14px;
  width: 100%;
  max-width: 760px;
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.22);
  animation: leadModalSlideIn 0.2s ease;
  overflow: hidden;
}

@keyframes leadModalSlideIn {
  from { opacity: 0; transform: translateY(-16px) scale(0.98); }
  to   { opacity: 1; transform: translateY(0)    scale(1);    }
}

/* ── Lead Modal Header ── */
.lead-modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 20px 14px;
  border-bottom: 1px solid var(--border, #e4e4e7);
  flex-shrink: 0;
}

.lead-modal-header-left {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1 1;
  min-width: 0;
}

.lead-modal-type-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: 5px;
  background: rgba(245, 158, 11, 0.12);
  color: #b45309;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  width: fit-content;
}

.lead-modal-title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-main, #18181b);
  line-height: 1.3;
}

.lead-modal-header-right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.lead-modal-score {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 700;
}
.lead-modal-score.lead-score-high {
  background: rgba(16, 185, 129, 0.14);
  color: #059669;
}
.lead-modal-score.lead-score-med {
  background: rgba(245, 158, 11, 0.14);
  color: #b45309;
}
.lead-modal-score.lead-score-low {
  background: rgba(239, 68, 68, 0.14);
  color: #dc2626;
}

.lead-modal-close-btn {
  background: transparent;
  border: 1px solid var(--border, #e4e4e7);
  border-radius: 8px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--text-muted, #71717a);
  transition: all 0.15s;
  font-size: 0.9rem;
}
.lead-modal-close-btn:hover {
  background: var(--hover-bg, #f4f4f5);
  color: var(--text-main, #18181b);
  border-color: var(--text-muted, #71717a);
}

/* ── Lead Modal Meta bar ── */
.lead-modal-meta-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  border-bottom: 1px solid var(--border, #e4e4e7);
  flex-shrink: 0;
  background: var(--bg-primary, #f9f9fa);
}

.lead-modal-meta-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  border-right: 1px solid var(--border, #e4e4e7);
  font-size: 0.8rem;
}
.lead-modal-meta-item:last-child { border-right: none; }
.lead-modal-meta-item > i {
  color: var(--text-muted, #71717a);
  font-size: 0.78rem;
  width: 14px;
  text-align: center;
}

.lead-meta-label {
  color: var(--text-muted, #71717a);
  font-weight: 500;
}
.lead-meta-value {
  color: var(--text-main, #18181b);
  font-weight: 600;
}

/* ── Lead Modal Body (scrollable) ── */
.lead-modal-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

/* ── Lead Modal Sections ── */
.lead-modal-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.lead-modal-section-title {
  margin: 0;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-muted, #71717a);
  display: flex;
  align-items: center;
  gap: 7px;
}
.lead-modal-section-title i { color: var(--accent, #2563eb); }

.lead-modal-section--action .lead-modal-section-title i { color: #f59e0b; }
.lead-modal-section--action {
  background: rgba(245, 158, 11, 0.06);
  border: 1px solid rgba(245, 158, 11, 0.2);
  border-radius: 10px;
  padding: 14px;
}

.lead-modal-summary-text {
  margin: 0;
  font-size: 0.9rem;
  color: var(--text-main, #18181b);
  line-height: 1.65;
}

.lead-modal-action-text {
  margin: 0;
  font-size: 0.88rem;
  color: var(--text-main, #18181b);
  line-height: 1.6;
}

/* ── Evidence list ── */
.lead-modal-evidence-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.lead-modal-evidence-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 0.87rem;
  color: var(--text-main, #18181b);
  line-height: 1.5;
  padding: 8px 12px;
  background: var(--bg-primary, #f9f9fa);
  border-radius: 8px;
  border: 1px solid var(--border, #e4e4e7);
}

.lead-evidence-icon {
  color: #059669;
  font-size: 0.8rem;
  margin-top: 2px;
  flex-shrink: 0;
}

/* ── Related entities list ── */
.lead-entities-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  background: var(--accent, #2563eb);
  color: #fff;
  border-radius: 10px;
  font-size: 0.7rem;
  font-weight: 700;
  margin-left: 4px;
}

.lead-entities-loading {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  color: var(--text-muted, #71717a);
  padding: 12px 0;
}

.lead-modal-entity-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.lead-modal-entity-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  background: var(--card-bg, #fff);
  border: 1px solid var(--border, #e4e4e7);
  border-radius: 8px;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.lead-modal-entity-row:hover {
  border-color: var(--accent, #2563eb);
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.08);
}

.lead-entity-info {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1;
  min-width: 0;
}

.lead-entity-type-chip {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  background: rgba(37, 99, 235, 0.1);
  color: var(--accent, #2563eb);
  flex-shrink: 0;
}

.lead-entity-name {
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--text-main, #18181b);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lead-entity-view-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: var(--accent, #2563eb);
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: opacity 0.15s, transform 0.12s;
}
.lead-entity-view-btn:hover {
  opacity: 0.88;
  transform: translateY(-1px);
}

/* =============================================================================
   Dark mode overrides — Lead Modal & Lead cards
   ============================================================================= */
[data-theme="dark"] .insight-card--lead { border-left-color: #f59e0b; }
[data-theme="dark"] .insight-type-badge.cross_domain_lead { background: rgba(245,158,11,.18); color: #fbbf24; }
[data-theme="dark"] .lead-score-badge.lead-score-high { background: rgba(16,185,129,.18); color: #34d399; }
[data-theme="dark"] .lead-score-badge.lead-score-med  { background: rgba(245,158,11,.18); color: #fbbf24; }
[data-theme="dark"] .lead-score-badge.lead-score-low  { background: rgba(239,68,68,.18);  color: #f87171; }

[data-theme="dark"] .lead-modal {
  background: var(--bg-secondary);
  border-color: var(--border-color);
}
[data-theme="dark"] .lead-modal-header { border-bottom-color: var(--border-color); }
[data-theme="dark"] .lead-modal-meta-bar { background: var(--bg-tertiary); border-bottom-color: var(--border-color); }
[data-theme="dark"] .lead-modal-meta-item { border-right-color: var(--border-color); }
[data-theme="dark"] .lead-modal-close-btn { border-color: var(--border-color); color: var(--text-secondary); }
[data-theme="dark"] .lead-modal-close-btn:hover { background: var(--bg-tertiary); }
[data-theme="dark"] .lead-modal-score.lead-score-high { background: rgba(16,185,129,.18); color: #34d399; }
[data-theme="dark"] .lead-modal-score.lead-score-med  { background: rgba(245,158,11,.18); color: #fbbf24; }
[data-theme="dark"] .lead-modal-score.lead-score-low  { background: rgba(239,68,68,.18);  color: #f87171; }
[data-theme="dark"] .lead-modal-summary-text { color: var(--text-primary); }
[data-theme="dark"] .lead-modal-action-text  { color: var(--text-primary); }
[data-theme="dark"] .lead-modal-section--action { background: rgba(245,158,11,.08); border-color: rgba(245,158,11,.25); }
[data-theme="dark"] .lead-modal-evidence-item { background: var(--bg-tertiary); border-color: var(--border-color); color: var(--text-primary); }
[data-theme="dark"] .lead-modal-entity-row { background: var(--bg-primary); border-color: var(--border-color); }
[data-theme="dark"] .lead-modal-entity-row:hover { border-color: var(--accent); }
[data-theme="dark"] .lead-entity-name { color: var(--text-primary); }
[data-theme="dark"] .lead-entity-type-chip { background: rgba(59,130,246,.18); color: #60a5fa; }

/* Dark overrides */
[data-theme="dark"] .tab-btn.active  { background: transparent; }
[data-theme="dark"] .analytics-content { background: var(--bg-primary); }
[data-theme="dark"] .insight-card    { background: var(--bg-secondary); border-color: var(--border-color); }
[data-theme="dark"] .insight-card.expanded { border-color: var(--accent); }
[data-theme="dark"] .insight-card-header.clickable:hover { background: var(--bg-tertiary); }
[data-theme="dark"] .insight-card-content { background: var(--bg-primary); border-top-color: var(--border-color); }
[data-theme="dark"] .insight-source-badge { background: var(--bg-tertiary); border-color: var(--border-color); }
[data-theme="dark"] .insight-filter-select,
[data-theme="dark"] .sort-btn        { background: var(--bg-secondary); border-color: var(--border-color); color: var(--text-secondary); }
[data-theme="dark"] .centrality-limit-select { background: var(--bg-secondary); border-color: var(--border-color); color: var(--text-primary); }
[data-theme="dark"] .centrality-table thead th { background: var(--bg-tertiary); border-bottom-color: var(--border-color); }
[data-theme="dark"] .centrality-table tbody tr { border-bottom-color: var(--border-color); }
[data-theme="dark"] .centrality-table tbody tr:hover { background: var(--bg-tertiary); }
[data-theme="dark"] .insight-type-badge.network_patterns      { background: rgba(59,130,246,.18);  color: #60a5fa; }
[data-theme="dark"] .insight-type-badge.entity_summary        { background: rgba(16,185,129,.18);  color: #34d399; }
[data-theme="dark"] .insight-type-badge.relationship_analysis { background: rgba(245,158,11,.18);  color: #fbbf24; }
[data-theme="dark"] .insight-type-badge.whiteboard_insight    { background: rgba(167,139,250,.18); color: #a78bfa; }
[data-theme="dark"] .insight-section li { background: rgba(59,130,246,.08); }
[data-theme="dark"] .insight-section.risk li { background: rgba(239,68,68,.08); }
[data-theme="dark"] .insight-sub-group li { background: var(--bg-tertiary); border-left-color: var(--border-color); }
[data-theme="dark"] .insight-full-summary p { color: var(--text-primary); }
`, "",{"version":3,"sources":["webpack://./src/styles/DashboardOverview.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,sCAAsC;EACtC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,4BAA4B;EAC5B,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,sCAAsC;EACtC,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,sCAAsC;EACtC,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA,qCAAqC;AACrC;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;;kFAEkF;AAClF;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;EACpB,qCAAqC;EACrC,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;AACrB;AACA,kBAAkB,gCAAgC,EAAE;AACpD;EACE,6BAA6B;EAC7B,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sCAAsC;AACxC;;AAEA,gCAAgC;AAChC,kBAAkB,iBAAiB,EAAE,iCAAiC,EAAE,kBAAkB,EAAE;AAC5F,mBAAmB,aAAa,EAAE,kBAAkB,EAAE;AACtD,uBAAuB,aAAa,EAAE;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,iCAAiC;EACjC,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;;kFAEkF;AAClF,wBAAwB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;AACX;AACA,wBAAwB,SAAS,EAAE,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACrG,uBAAuB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,iCAAiC,EAAE;AAC5H;EACE,iBAAiB;EACjB,wCAAwC;EACxC,kBAAkB;EAClB,gCAAgC;EAChC,gCAAgC;EAChC,kBAAkB;AACpB;AACA,oBAAoB,gBAAgB,EAAE;AACtC,0BAA0B,WAAW,EAAE,yBAAyB,EAAE,mBAAmB,EAAE;AACvF;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,iCAAiC;EACjC,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;AACrB;AACA;EACE,+CAA+C;EAC/C,2BAA2B;AAC7B;AACA,mCAAmC,oCAAoC,EAAE;AACzE,wCAAwC,mBAAmB,EAAE;AAC7D,uBAAuB,kBAAkB,EAAE;AAC3C,eAAe,iCAAiC,EAAE,gBAAgB,EAAE;AACpE,eAAe,gBAAgB,EAAE;AACjC,eAAe,gBAAgB,EAAE,6BAA6B,EAAE;AAChE,eAAe,kBAAkB,EAAE;AACnC;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;kFAEkF;AAClF,sBAAsB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACxE,4BAA4B,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAE9E,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;AACA,yBAAyB,SAAS,EAAE,eAAe,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACnG,wBAAwB,iBAAiB,EAAE,kBAAkB,EAAE,iCAAiC,EAAE;;AAElG,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,cAAc,EAAE;AACnF;EACE,iBAAiB;EACjB,wCAAwC;EACxC,kBAAkB;EAClB,gCAAgC;EAChC,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,wCAAwC;EACxC,kBAAkB;EAClB,gCAAgC;EAChC,iCAAiC;EACjC,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA,kBAAkB,oCAAoC,EAAE,6BAA6B,EAAE;;AAEvF,+BAA+B;AAC/B,gBAAgB,gBAAgB,EAAE,UAAU,EAAE,iBAAiB,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAClH,mBAAmB,kBAAkB,EAAE,iCAAiC,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACxH,qBAAqB,6BAA6B,EAAE,WAAW,EAAE,kBAAkB,EAAE;;AAErF,iBAAiB;AACjB,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAEnE,uBAAuB;AACvB;EACE,gCAAgC;EAChC,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA,uBAAuB,sCAAsC,EAAE;AAC/D,yBAAyB,oCAAoC,EAAE;;AAE/D;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,8BAA8B;AAChC;AACA,iCAAiC,eAAe,EAAE,2BAA2B,EAAE;AAC/E,uCAAuC,oCAAoC,EAAE;;AAE7E;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,QAAQ;EACR,SAAO;EACP,YAAY;AACd;;AAEA,eAAe;AACf;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,cAAc;AAChB;AACA,4CAA4C,+BAA+B,GAAG,cAAc,EAAE;AAC9F,4CAA4C,gCAAgC,EAAE,cAAc,EAAE;AAC9F,4CAA4C,gCAAgC,EAAE,cAAc,EAAE;AAC9F,8CAA8C,gCAAgC,EAAE,cAAc,EAAE;;AAEhG,yBAAyB;AACzB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,iCAAiC;EACjC,wCAAwC;EACxC,mBAAmB;EACnB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,SAAO;EACP,kBAAkB;EAClB,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,iCAAiC;AACnC;AACA,gBAAgB,mBAAmB,EAAE;;AAErC,kBAAkB;AAClB;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sCAAsC;AACxC;;AAEA,0BAA0B;AAC1B,mBAAmB,aAAa,EAAE,yBAAyB,EAAE;AAC7D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wCAAwC;AAC1C;AACA,yBAAyB,aAAa,EAAE,2BAA2B,EAAE;AACrE;EACE,mBAAmB;EACnB,WAAW;AACb;AACA,+BAA+B,aAAa,EAAE,2BAA2B,EAAE;;AAE3E,iBAAiB;AACjB,wBAAwB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACzE;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,iCAAiC;AACnC;AACA,0BAA0B,SAAS,EAAE,kBAAkB,EAAE,gCAAgC,EAAE,gBAAgB,EAAE;;AAE7G,qBAAqB;AACrB,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACpE;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA,wBAAwB,6BAA6B,EAAE;AACvD,6BAA6B,cAAc,EAAE;AAC7C;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,0BAA0B;EAC1B,6CAA6C;EAC7C,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA,2BAA2B,0BAA0B,EAAE,+BAA+B,EAAE;;AAExF,mDAAmD;AACnD,qBAAqB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACtE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA,uBAAuB,6BAA6B,EAAE;AACtD;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,yBAAyB;EACzB,6CAA6C;EAC7C,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;;kFAEkF;AAClF;EACE,8BAA8B;AAChC;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,qDAAqD;AACrD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;;kFAEkF;AAClF;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;EACxC,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,OAAO,UAAU,EAAE,wCAAwC,EAAE;EAC7D,OAAO,UAAU,EAAE,oCAAoC,KAAK;AAC9D;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;EACjC,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,+CAA+C;EAC/C,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,8CAA8C;EAC9C,iBAAiB;AACnB;AACA,mCAAmC,kBAAkB,EAAE;AACvD;EACE,iCAAiC;EACjC,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA,8BAA8B,6BAA6B,EAAE;;AAE7D,0DAA0D,cAAc,EAAE;AAC1E;EACE,oCAAoC;EACpC,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kCAAkC;EAClC,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,wCAAwC;EACxC,kBAAkB;EAClB,gDAAgD;AAClD;AACA;EACE,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kCAAkC;EAClC,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;;kFAEkF;AAClF,0CAA0C,0BAA0B,EAAE;AACtE,4DAA4D,gCAAgC,EAAE,cAAc,EAAE;AAC9G,wDAAwD,gCAAgC,EAAE,cAAc,EAAE;AAC1G,wDAAwD,gCAAgC,EAAE,cAAc,EAAE;AAC1G,wDAAwD,+BAA+B,GAAG,cAAc,EAAE;;AAE1G;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;AACA,yCAAyC,wCAAwC,EAAE;AACnF,2CAA2C,8BAA8B,EAAE,wCAAwC,EAAE;AACrH,4CAA4C,uCAAuC,EAAE;AACrF,4CAA4C,iCAAiC,EAAE,4BAA4B,EAAE;AAC7G,kDAAkD,8BAA8B,EAAE;AAClF,wDAAwD,gCAAgC,EAAE,cAAc,EAAE;AAC1G,wDAAwD,gCAAgC,EAAE,cAAc,EAAE;AAC1G,wDAAwD,+BAA+B,GAAG,cAAc,EAAE;AAC1G,+CAA+C,0BAA0B,EAAE;AAC3E,+CAA+C,0BAA0B,EAAE;AAC3E,kDAAkD,gCAAgC,EAAE,kCAAkC,EAAE;AACxH,gDAAgD,8BAA8B,EAAE,iCAAiC,EAAE,0BAA0B,EAAE;AAC/I,6CAA6C,6BAA6B,EAAE,iCAAiC,EAAE;AAC/G,mDAAmD,2BAA2B,EAAE;AAChF,wCAAwC,0BAA0B,EAAE;AACpE,6CAA6C,gCAAgC,EAAE,cAAc,EAAE;;AAE/F,mBAAmB;AACnB,uCAAuC,uBAAuB,EAAE;AAChE,yCAAyC,6BAA6B,EAAE;AACxE,uCAAuC,+BAA+B,EAAE,iCAAiC,EAAE;AAC3G,6CAA6C,2BAA2B,EAAE;AAC1E,2DAA2D,8BAA8B,EAAE;AAC3F,4CAA4C,6BAA6B,EAAE,qCAAqC,EAAE;AAClH,4CAA4C,8BAA8B,EAAE,iCAAiC,EAAE;AAC/G;uCACuC,+BAA+B,EAAE,iCAAiC,EAAE,4BAA4B,EAAE;AACzI,+CAA+C,+BAA+B,EAAE,iCAAiC,EAAE,0BAA0B,EAAE;AAC/I,iDAAiD,8BAA8B,EAAE,wCAAwC,EAAE;AAC3H,iDAAiD,wCAAwC,EAAE;AAC3F,uDAAuD,8BAA8B,EAAE;AACvF,gEAAgE,gCAAgC,GAAG,cAAc,EAAE;AACnH,gEAAgE,gCAAgC,GAAG,cAAc,EAAE;AACnH,gEAAgE,gCAAgC,GAAG,cAAc,EAAE;AACnH,gEAAgE,iCAAiC,EAAE,cAAc,EAAE;AACnH,0CAA0C,gCAAgC,EAAE;AAC5E,+CAA+C,+BAA+B,EAAE;AAChF,4CAA4C,8BAA8B,EAAE,sCAAsC,EAAE;AACpH,8CAA8C,0BAA0B,EAAE","sourcesContent":[".dashboard-overview {\n  padding: var(--spacing-md);\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.metrics-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: var(--spacing-lg);\n  margin-bottom: var(--spacing-xl);\n}\n\n.metric-card {\n  background: var(--card-bg);\n  border: 1px solid var(--border);\n  border-radius: var(--border-radius-lg);\n  padding: var(--spacing-lg);\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  box-shadow: var(--shadow-sm);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.metric-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n\n.metric-content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-xs);\n}\n\n.metric-label {\n  color: var(--text-muted);\n  font-size: var(--font-size-sm);\n  font-weight: 500;\n}\n\n.metric-value {\n  color: var(--text-main);\n  font-size: var(--font-size-xxxl);\n  font-weight: 700;\n  line-height: 1;\n}\n\n.metric-trend {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: var(--font-size-xs);\n  margin-top: var(--spacing-xs);\n}\n\n.trend-up {\n  color: var(--success);\n}\n\n.trend-down {\n  color: var(--danger);\n}\n\n.metric-icon {\n  background: var(--hover-bg);\n  color: var(--accent);\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5rem;\n}\n\n.charts-section {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n  gap: var(--spacing-lg);\n  margin-bottom: var(--spacing-xl);\n}\n\n.chart-card {\n  background: var(--card-bg);\n  border: 1px solid var(--border);\n  border-radius: var(--border-radius-lg);\n  padding: var(--spacing-lg);\n  box-shadow: var(--shadow-sm);\n}\n\n.chart-header {\n  margin-bottom: var(--spacing-lg);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.chart-title {\n  color: var(--text-main);\n  font-size: var(--font-size-lg);\n  font-weight: 600;\n  margin: 0;\n}\n\n.services-section {\n  background: var(--card-bg);\n  border: 1px solid var(--border);\n  border-radius: var(--border-radius-lg);\n  padding: var(--spacing-lg);\n  box-shadow: var(--shadow-sm);\n}\n\n.section-header {\n  margin-bottom: var(--spacing-lg);\n}\n\n.section-title {\n  color: var(--text-main);\n  font-size: var(--font-size-xl);\n  font-weight: 600;\n  margin: 0;\n}\n\n.services-table-container {\n  overflow-x: auto;\n}\n\n.services-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.services-table th {\n  text-align: left;\n  padding: var(--spacing-md);\n  color: var(--text-muted);\n  font-size: var(--font-size-sm);\n  font-weight: 600;\n  border-bottom: 1px solid var(--border);\n}\n\n.services-table td {\n  padding: var(--spacing-md);\n  border-bottom: 1px solid var(--border);\n  color: var(--text-main);\n}\n\n.services-table tr:last-child td {\n  border-bottom: none;\n}\n\n.services-table tr {\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.services-table tr:hover {\n  background-color: var(--hover-bg);\n}\n\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 12px;\n  border-radius: 9999px;\n  font-size: var(--font-size-xs);\n  font-weight: 500;\n}\n\n.status-active {\n  background: rgba(16, 185, 129, 0.1);\n  color: var(--success);\n}\n\n.status-inactive {\n  background: rgba(239, 68, 68, 0.1);\n  color: var(--danger);\n}\n\n.provider-list {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.provider-pill {\n  background: var(--hover-bg);\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: var(--font-size-xs);\n  color: var(--text-muted);\n}\n\n/* Modal styles for service details */\n.service-details-modal {\n  padding: var(--spacing-lg);\n}\n\n.service-detail-row {\n  display: flex;\n  justify-content: space-between;\n  padding: var(--spacing-md) 0;\n  border-bottom: 1px solid var(--border);\n}\n\n.service-detail-row:last-child {\n  border-bottom: none;\n}\n\n.detail-label {\n  color: var(--text-muted);\n  font-weight: 500;\n}\n\n.detail-value {\n  color: var(--text-main);\n  font-weight: 600;\n}\n\n@media (max-width: 768px) {\n  .charts-section {\n    grid-template-columns: 1fr;\n  }\n  \n  .metric-card {\n    padding: var(--spacing-md);\n  }\n  \n  .metric-value {\n    font-size: var(--font-size-xxl);\n  }\n}\n\n/* =============================================================================\n   GraphAnalytics — Tab bar\n   ============================================================================= */\n.graph-analytics-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n}\n\n.analytics-tabs {\n  display: flex;\n  gap: 4px;\n  padding: 12px 16px 0;\n  background: var(--bg-secondary, #fff);\n  border-bottom: 2px solid var(--border, #e4e4e7);\n  flex-shrink: 0;\n}\n\n.tab-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 18px;\n  border: none;\n  background: transparent;\n  color: var(--text-muted, #71717a);\n  cursor: pointer;\n  border-bottom: 3px solid transparent;\n  font-size: 0.875rem;\n  font-weight: 500;\n  white-space: nowrap;\n  transition: color .2s, border-color .2s;\n  margin-bottom: -2px;\n}\n.tab-btn:hover  { color: var(--text-main, #18181b); }\n.tab-btn.active {\n  color: var(--accent, #2563eb);\n  border-bottom-color: var(--accent, #2563eb);\n  font-weight: 600;\n}\n\n.analytics-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n  background: var(--bg-primary, #f4f4f5);\n}\n\n/* additional chart sub-styles */\n.chart-subtitle { margin: 4px 0 0 0; color: var(--text-muted, #71717a); font-size: 0.82rem; }\n.chart-container { height: 280px; position: relative; }\n.chart-container-bar { height: 320px; }\n.no-data {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 40px;\n  color: var(--text-muted, #71717a);\n  text-align: center;\n}\n.loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 40px;\n  color: var(--text-muted, #71717a);\n  font-size: 0.9rem;\n}\n\n/* =============================================================================\n   GraphAnalytics — Centrality tab\n   ============================================================================= */\n.centrality-container { display: flex; flex-direction: column; gap: 16px; }\n.centrality-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n.centrality-header h3 { margin: 0; font-size: 1.05rem; display: flex; align-items: center; gap: 8px; }\n.centrality-controls { display: flex; align-items: center; gap: 8px; font-size: 0.85rem; color: var(--text-muted, #71717a); }\n.centrality-limit-select {\n  padding: 6px 10px;\n  border: 1px solid var(--border, #e4e4e7);\n  border-radius: 6px;\n  background: var(--card-bg, #fff);\n  color: var(--text-main, #18181b);\n  font-size: 0.85rem;\n}\n.centrality-table { overflow-x: auto; }\n.centrality-table table { width: 100%; border-collapse: collapse; font-size: 0.875rem; }\n.centrality-table thead th {\n  text-align: left;\n  padding: 10px 14px;\n  background: var(--hover-bg, #f4f4f5);\n  color: var(--text-muted, #71717a);\n  font-weight: 600;\n  border-bottom: 1px solid var(--border, #e4e4e7);\n  white-space: nowrap;\n}\n.centrality-table tbody tr {\n  border-bottom: 1px solid var(--border, #f4f4f5);\n  transition: background .15s;\n}\n.centrality-table tbody tr:hover { background: var(--hover-bg, #f8fafc); }\n.centrality-table tbody tr:last-child { border-bottom: none; }\n.centrality-table td { padding: 10px 14px; }\n.rank-cell   { color: var(--text-muted, #71717a); font-weight: 600; }\n.entity-cell { font-weight: 500; }\n.degree-cell { font-weight: 700; color: var(--accent, #2563eb); }\n.text-center { text-align: center; }\n.type-badge  {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 5px;\n  font-size: 0.7rem;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n/* =============================================================================\n   GraphAnalytics — AI Insights tab\n   ============================================================================= */\n.insights-container { display: flex; flex-direction: column; gap: 16px; }\n.insights-history-section { display: flex; flex-direction: column; gap: 14px; }\n\n.insights-header {}\n.insights-title-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n.insights-title-row h3 { margin: 0; font-size: 1rem; display: flex; align-items: center; gap: 8px; }\n.insights-description { margin: 4px 0 0 0; font-size: 0.82rem; color: var(--text-muted, #71717a); }\n\n.insights-controls { display: flex; align-items: center; gap: 8px; flex-shrink: 0; }\n.insight-filter-select {\n  padding: 7px 10px;\n  border: 1px solid var(--border, #e4e4e7);\n  border-radius: 6px;\n  background: var(--card-bg, #fff);\n  color: var(--text-main, #18181b);\n  font-size: 0.82rem;\n}\n.sort-btn {\n  padding: 7px 10px;\n  border: 1px solid var(--border, #e4e4e7);\n  border-radius: 6px;\n  background: var(--card-bg, #fff);\n  color: var(--text-muted, #71717a);\n  cursor: pointer;\n  font-size: 0.85rem;\n  transition: all .2s;\n}\n.sort-btn:hover { border-color: var(--accent, #2563eb); color: var(--accent, #2563eb); }\n\n/* Insight Tips (empty state) */\n.insight-tips { list-style: none; padding: 0; margin: 8px 0 0 0; display: flex; flex-direction: column; gap: 6px; }\n.insight-tips li { font-size: 0.82rem; color: var(--text-muted, #71717a); display: flex; align-items: center; gap: 8px; }\n.insight-tips li i { color: var(--accent, #2563eb); width: 14px; text-align: center; }\n\n/* Insight list */\n.insights-list { display: flex; flex-direction: column; gap: 10px; }\n\n/* ── Insight Card ── */\n.insight-card {\n  background: var(--card-bg, #fff);\n  border: 1px solid var(--border, #e4e4e7);\n  border-radius: 10px;\n  overflow: hidden;\n  transition: box-shadow .2s;\n}\n.insight-card:hover  { box-shadow: 0 4px 12px rgba(0,0,0,.08); }\n.insight-card.expanded { border-color: var(--accent, #2563eb); }\n\n.insight-card-header {\n  padding: 12px 14px;\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  justify-content: space-between;\n}\n.insight-card-header.clickable { cursor: pointer; transition: background .15s; }\n.insight-card-header.clickable:hover { background: var(--hover-bg, #f8fafc); }\n\n.insight-header-main {\n  display: flex;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: 8px;\n  flex: 1;\n  min-width: 0;\n}\n\n/* Type badge */\n.insight-type-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 3px 9px;\n  border-radius: 5px;\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: capitalize;\n  white-space: nowrap;\n  flex-shrink: 0;\n  background: rgba(99,102,241,.12);\n  color: #4f46e5;\n}\n.insight-type-badge.network_patterns      { background: rgba(37,99,235,.12);  color: #1d4ed8; }\n.insight-type-badge.entity_summary        { background: rgba(16,185,129,.12); color: #059669; }\n.insight-type-badge.relationship_analysis { background: rgba(245,158,11,.12); color: #b45309; }\n.insight-type-badge.whiteboard_analytics    { background: rgba(139,92,246,.12); color: #7c3aed; }\n\n/* Source context badge */\n.insight-source-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 3px 9px;\n  border-radius: 5px;\n  font-size: 0.72rem;\n  font-weight: 500;\n  background: var(--hover-bg, #f4f4f5);\n  color: var(--text-muted, #71717a);\n  border: 1px solid var(--border, #e4e4e7);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n/* Summary preview text */\n.insight-summary-preview {\n  flex: 1;\n  font-size: 0.82rem;\n  color: var(--text-muted, #71717a);\n  line-height: 1.45;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  min-width: 120px;\n}\n\n.insight-header-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  font-size: 0.75rem;\n  color: var(--text-muted, #71717a);\n}\n.insight-time { white-space: nowrap; }\n\n/* Expanded body */\n.insight-card-content {\n  padding: 14px 16px;\n  border-top: 1px solid var(--border, #e4e4e7);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  background: var(--bg-primary, #fafafa);\n}\n\n/* Navigation button row */\n.insight-nav-row { display: flex; justify-content: flex-end; }\n.insight-nav-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 7px 14px;\n  background: var(--accent, #2563eb);\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.82rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity .15s, transform .12s;\n}\n.insight-nav-btn:hover { opacity: 0.88; transform: translateY(-1px); }\n.insight-nav-btn--lead {\n  background: #f59e0b;\n  color: #fff;\n}\n.insight-nav-btn--lead:hover { opacity: 0.88; transform: translateY(-1px); }\n\n/* Full summary */\n.insight-full-summary { display: flex; flex-direction: column; gap: 6px; }\n.insight-full-summary h4 {\n  margin: 0;\n  font-size: 0.78rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: .4px;\n  color: var(--text-muted, #71717a);\n}\n.insight-full-summary p { margin: 0; font-size: 0.88rem; color: var(--text-main, #18181b); line-height: 1.6; }\n\n/* Content sections */\n.insight-section { display: flex; flex-direction: column; gap: 8px; }\n.insight-section h4 {\n  margin: 0;\n  font-size: 0.78rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: .4px;\n  color: var(--text-muted, #71717a);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.insight-section h4 i { color: var(--accent, #2563eb); }\n.insight-section.risk h4 i { color: #ef4444; }\n.insight-section ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n.insight-section li {\n  font-size: 0.85rem;\n  color: var(--text-main, #18181b);\n  line-height: 1.5;\n  padding: 5px 10px 5px 12px;\n  border-left: 3px solid var(--accent, #2563eb);\n  background: rgba(37,99,235,.04);\n  border-radius: 0 5px 5px 0;\n}\n.insight-section.risk li { border-left-color: #ef4444; background: rgba(239,68,68,.04); }\n\n/* Sub-groups (whiteboard board_summary sections) */\n.insight-sub-group { display: flex; flex-direction: column; gap: 5px; }\n.insight-sub-label {\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: .4px;\n  color: var(--text-muted, #71717a);\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n.insight-sub-label i { color: var(--accent, #2563eb); }\n.insight-sub-group ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.insight-sub-group li {\n  font-size: 0.83rem;\n  color: var(--text-main, #18181b);\n  line-height: 1.45;\n  padding: 4px 8px 4px 10px;\n  border-left: 2px solid var(--border, #e4e4e7);\n  background: var(--hover-bg, #f8fafc);\n  border-radius: 0 4px 4px 0;\n}\n\n/* =============================================================================\n   Cross Domain Lead — card badge & score pill\n   ============================================================================= */\n.insight-card--lead {\n  border-left: 3px solid #f59e0b;\n}\n.insight-card--lead.expanded {\n  border-color: #f59e0b;\n}\n\n.insight-type-badge.cross_domain_lead {\n  background: rgba(245, 158, 11, 0.12);\n  color: #b45309;\n}\n\n/* Lead score pill shown in the insight card header */\n.lead-score-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 9px;\n  border-radius: 5px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.lead-score-badge.lead-score-high {\n  background: rgba(16, 185, 129, 0.12);\n  color: #059669;\n  border: 1px solid rgba(16, 185, 129, 0.3);\n}\n.lead-score-badge.lead-score-med {\n  background: rgba(245, 158, 11, 0.12);\n  color: #b45309;\n  border: 1px solid rgba(245, 158, 11, 0.3);\n}\n.lead-score-badge.lead-score-low {\n  background: rgba(239, 68, 68, 0.12);\n  color: #dc2626;\n  border: 1px solid rgba(239, 68, 68, 0.3);\n}\n\n/* =============================================================================\n   Lead Modal — overlay & shell\n   ============================================================================= */\n.lead-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(3px);\n  z-index: 1100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  animation: leadModalFadeIn 0.18s ease;\n}\n\n@keyframes leadModalFadeIn {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n.lead-modal {\n  background: var(--card-bg, #fff);\n  border: 1px solid var(--border, #e4e4e7);\n  border-top: 4px solid #f59e0b;\n  border-radius: 14px;\n  width: 100%;\n  max-width: 760px;\n  max-height: 88vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.22);\n  animation: leadModalSlideIn 0.2s ease;\n  overflow: hidden;\n}\n\n@keyframes leadModalSlideIn {\n  from { opacity: 0; transform: translateY(-16px) scale(0.98); }\n  to   { opacity: 1; transform: translateY(0)    scale(1);    }\n}\n\n/* ── Lead Modal Header ── */\n.lead-modal-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 18px 20px 14px;\n  border-bottom: 1px solid var(--border, #e4e4e7);\n  flex-shrink: 0;\n}\n\n.lead-modal-header-left {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  flex: 1;\n  min-width: 0;\n}\n\n.lead-modal-type-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 10px;\n  border-radius: 5px;\n  background: rgba(245, 158, 11, 0.12);\n  color: #b45309;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  width: fit-content;\n}\n\n.lead-modal-title {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text-main, #18181b);\n  line-height: 1.3;\n}\n\n.lead-modal-header-right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.lead-modal-score {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 5px 12px;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  font-weight: 700;\n}\n.lead-modal-score.lead-score-high {\n  background: rgba(16, 185, 129, 0.14);\n  color: #059669;\n}\n.lead-modal-score.lead-score-med {\n  background: rgba(245, 158, 11, 0.14);\n  color: #b45309;\n}\n.lead-modal-score.lead-score-low {\n  background: rgba(239, 68, 68, 0.14);\n  color: #dc2626;\n}\n\n.lead-modal-close-btn {\n  background: transparent;\n  border: 1px solid var(--border, #e4e4e7);\n  border-radius: 8px;\n  width: 34px;\n  height: 34px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--text-muted, #71717a);\n  transition: all 0.15s;\n  font-size: 0.9rem;\n}\n.lead-modal-close-btn:hover {\n  background: var(--hover-bg, #f4f4f5);\n  color: var(--text-main, #18181b);\n  border-color: var(--text-muted, #71717a);\n}\n\n/* ── Lead Modal Meta bar ── */\n.lead-modal-meta-bar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0;\n  border-bottom: 1px solid var(--border, #e4e4e7);\n  flex-shrink: 0;\n  background: var(--bg-primary, #f9f9fa);\n}\n\n.lead-modal-meta-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 16px;\n  border-right: 1px solid var(--border, #e4e4e7);\n  font-size: 0.8rem;\n}\n.lead-modal-meta-item:last-child { border-right: none; }\n.lead-modal-meta-item > i {\n  color: var(--text-muted, #71717a);\n  font-size: 0.78rem;\n  width: 14px;\n  text-align: center;\n}\n\n.lead-meta-label {\n  color: var(--text-muted, #71717a);\n  font-weight: 500;\n}\n.lead-meta-value {\n  color: var(--text-main, #18181b);\n  font-weight: 600;\n}\n\n/* ── Lead Modal Body (scrollable) ── */\n.lead-modal-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 18px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n/* ── Lead Modal Sections ── */\n.lead-modal-section {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.lead-modal-section-title {\n  margin: 0;\n  font-size: 0.78rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text-muted, #71717a);\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n.lead-modal-section-title i { color: var(--accent, #2563eb); }\n\n.lead-modal-section--action .lead-modal-section-title i { color: #f59e0b; }\n.lead-modal-section--action {\n  background: rgba(245, 158, 11, 0.06);\n  border: 1px solid rgba(245, 158, 11, 0.2);\n  border-radius: 10px;\n  padding: 14px;\n}\n\n.lead-modal-summary-text {\n  margin: 0;\n  font-size: 0.9rem;\n  color: var(--text-main, #18181b);\n  line-height: 1.65;\n}\n\n.lead-modal-action-text {\n  margin: 0;\n  font-size: 0.88rem;\n  color: var(--text-main, #18181b);\n  line-height: 1.6;\n}\n\n/* ── Evidence list ── */\n.lead-modal-evidence-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.lead-modal-evidence-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  font-size: 0.87rem;\n  color: var(--text-main, #18181b);\n  line-height: 1.5;\n  padding: 8px 12px;\n  background: var(--bg-primary, #f9f9fa);\n  border-radius: 8px;\n  border: 1px solid var(--border, #e4e4e7);\n}\n\n.lead-evidence-icon {\n  color: #059669;\n  font-size: 0.8rem;\n  margin-top: 2px;\n  flex-shrink: 0;\n}\n\n/* ── Related entities list ── */\n.lead-entities-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  background: var(--accent, #2563eb);\n  color: #fff;\n  border-radius: 10px;\n  font-size: 0.7rem;\n  font-weight: 700;\n  margin-left: 4px;\n}\n\n.lead-entities-loading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.85rem;\n  color: var(--text-muted, #71717a);\n  padding: 12px 0;\n}\n\n.lead-modal-entity-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.lead-modal-entity-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 14px;\n  background: var(--card-bg, #fff);\n  border: 1px solid var(--border, #e4e4e7);\n  border-radius: 8px;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n.lead-modal-entity-row:hover {\n  border-color: var(--accent, #2563eb);\n  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.08);\n}\n\n.lead-entity-info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 1;\n  min-width: 0;\n}\n\n.lead-entity-type-chip {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  background: rgba(37, 99, 235, 0.1);\n  color: var(--accent, #2563eb);\n  flex-shrink: 0;\n}\n\n.lead-entity-name {\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: var(--text-main, #18181b);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lead-entity-view-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: var(--accent, #2563eb);\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.78rem;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  flex-shrink: 0;\n  transition: opacity 0.15s, transform 0.12s;\n}\n.lead-entity-view-btn:hover {\n  opacity: 0.88;\n  transform: translateY(-1px);\n}\n\n/* =============================================================================\n   Dark mode overrides — Lead Modal & Lead cards\n   ============================================================================= */\n[data-theme=\"dark\"] .insight-card--lead { border-left-color: #f59e0b; }\n[data-theme=\"dark\"] .insight-type-badge.cross_domain_lead { background: rgba(245,158,11,.18); color: #fbbf24; }\n[data-theme=\"dark\"] .lead-score-badge.lead-score-high { background: rgba(16,185,129,.18); color: #34d399; }\n[data-theme=\"dark\"] .lead-score-badge.lead-score-med  { background: rgba(245,158,11,.18); color: #fbbf24; }\n[data-theme=\"dark\"] .lead-score-badge.lead-score-low  { background: rgba(239,68,68,.18);  color: #f87171; }\n\n[data-theme=\"dark\"] .lead-modal {\n  background: var(--bg-secondary);\n  border-color: var(--border-color);\n}\n[data-theme=\"dark\"] .lead-modal-header { border-bottom-color: var(--border-color); }\n[data-theme=\"dark\"] .lead-modal-meta-bar { background: var(--bg-tertiary); border-bottom-color: var(--border-color); }\n[data-theme=\"dark\"] .lead-modal-meta-item { border-right-color: var(--border-color); }\n[data-theme=\"dark\"] .lead-modal-close-btn { border-color: var(--border-color); color: var(--text-secondary); }\n[data-theme=\"dark\"] .lead-modal-close-btn:hover { background: var(--bg-tertiary); }\n[data-theme=\"dark\"] .lead-modal-score.lead-score-high { background: rgba(16,185,129,.18); color: #34d399; }\n[data-theme=\"dark\"] .lead-modal-score.lead-score-med  { background: rgba(245,158,11,.18); color: #fbbf24; }\n[data-theme=\"dark\"] .lead-modal-score.lead-score-low  { background: rgba(239,68,68,.18);  color: #f87171; }\n[data-theme=\"dark\"] .lead-modal-summary-text { color: var(--text-primary); }\n[data-theme=\"dark\"] .lead-modal-action-text  { color: var(--text-primary); }\n[data-theme=\"dark\"] .lead-modal-section--action { background: rgba(245,158,11,.08); border-color: rgba(245,158,11,.25); }\n[data-theme=\"dark\"] .lead-modal-evidence-item { background: var(--bg-tertiary); border-color: var(--border-color); color: var(--text-primary); }\n[data-theme=\"dark\"] .lead-modal-entity-row { background: var(--bg-primary); border-color: var(--border-color); }\n[data-theme=\"dark\"] .lead-modal-entity-row:hover { border-color: var(--accent); }\n[data-theme=\"dark\"] .lead-entity-name { color: var(--text-primary); }\n[data-theme=\"dark\"] .lead-entity-type-chip { background: rgba(59,130,246,.18); color: #60a5fa; }\n\n/* Dark overrides */\n[data-theme=\"dark\"] .tab-btn.active  { background: transparent; }\n[data-theme=\"dark\"] .analytics-content { background: var(--bg-primary); }\n[data-theme=\"dark\"] .insight-card    { background: var(--bg-secondary); border-color: var(--border-color); }\n[data-theme=\"dark\"] .insight-card.expanded { border-color: var(--accent); }\n[data-theme=\"dark\"] .insight-card-header.clickable:hover { background: var(--bg-tertiary); }\n[data-theme=\"dark\"] .insight-card-content { background: var(--bg-primary); border-top-color: var(--border-color); }\n[data-theme=\"dark\"] .insight-source-badge { background: var(--bg-tertiary); border-color: var(--border-color); }\n[data-theme=\"dark\"] .insight-filter-select,\n[data-theme=\"dark\"] .sort-btn        { background: var(--bg-secondary); border-color: var(--border-color); color: var(--text-secondary); }\n[data-theme=\"dark\"] .centrality-limit-select { background: var(--bg-secondary); border-color: var(--border-color); color: var(--text-primary); }\n[data-theme=\"dark\"] .centrality-table thead th { background: var(--bg-tertiary); border-bottom-color: var(--border-color); }\n[data-theme=\"dark\"] .centrality-table tbody tr { border-bottom-color: var(--border-color); }\n[data-theme=\"dark\"] .centrality-table tbody tr:hover { background: var(--bg-tertiary); }\n[data-theme=\"dark\"] .insight-type-badge.network_patterns      { background: rgba(59,130,246,.18);  color: #60a5fa; }\n[data-theme=\"dark\"] .insight-type-badge.entity_summary        { background: rgba(16,185,129,.18);  color: #34d399; }\n[data-theme=\"dark\"] .insight-type-badge.relationship_analysis { background: rgba(245,158,11,.18);  color: #fbbf24; }\n[data-theme=\"dark\"] .insight-type-badge.whiteboard_insight    { background: rgba(167,139,250,.18); color: #a78bfa; }\n[data-theme=\"dark\"] .insight-section li { background: rgba(59,130,246,.08); }\n[data-theme=\"dark\"] .insight-section.risk li { background: rgba(239,68,68,.08); }\n[data-theme=\"dark\"] .insight-sub-group li { background: var(--bg-tertiary); border-left-color: var(--border-color); }\n[data-theme=\"dark\"] .insight-full-summary p { color: var(--text-primary); }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
